"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedLinesOfCoverage = void 0;
var react_1 = require("react");
var reducer_1 = require("./reducer");
var types_1 = require("./types");
function useSelectedLinesOfCoverage(initialLineOfCoverageTypeDetails) {
    var _a = react_1.useReducer(reducer_1.reducer, {
        selectedLineOfCoverageTypeDetails: initialLineOfCoverageTypeDetails,
        isDeletingCoverage: false,
    }), state = _a[0], dispatch = _a[1];
    var removeLoc = function (index, isDeleting) {
        if (isDeleting === void 0) { isDeleting = false; }
        dispatch({
            type: types_1.LineOfCoverageEditorActionType.REMOVE_SELECTED_LOC,
            payload: {
                index: index,
                isDeleting: isDeleting,
            },
        });
    };
    var addLoc = function (lineOfCoverage) {
        dispatch({
            type: types_1.LineOfCoverageEditorActionType.ADD_SELECTED_LOC,
            payload: {
                lineOfCoverage: lineOfCoverage,
            },
        });
    };
    var updateLocDisplayName = function (index, displayName) {
        dispatch({
            type: types_1.LineOfCoverageEditorActionType.UPDATE_DISPLAY_NAME,
            payload: {
                index: index,
                displayName: displayName,
            },
        });
    };
    return {
        selectedLineOfCoverageTypeDetails: state.selectedLineOfCoverageTypeDetails,
        isDeleting: state.isDeletingCoverage,
        removeLoc: removeLoc,
        addLoc: addLoc,
        updateLocDisplayName: updateLocDisplayName,
    };
}
exports.useSelectedLinesOfCoverage = useSelectedLinesOfCoverage;
